import React from "react";
import styles from "./data-acquisition-type-monitoring-info-icon-and-text-wrapper.module.scss";
import { InfoIconAndText } from "@components/atoms/info-icon-and-text/info-icon-and-text";
import { useI18N } from "@src/language/language-context";

const cssClassName =
  "data-acquisition-type-monitoring-info-icon-and-text-wrapper";

export const DataAcquisitionTypeMonitoringInfoIconAndTextWrapper = () => {
  const i18n = useI18N();
  return (
    <div className={styles[cssClassName]}>
      <InfoIconAndText
        text={i18n("modules.ourNodeDetailsPanel.monitoringInfoText")}
      />
    </div>
  );
};
